import {inject, ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Project} from 'src/app/core/model/project';
import {CreateProjectDialogComponent} from '../create-project-dialog/create-project-dialog.component';
import {RewardCoin} from 'src/app/core/model/reward';
import {RolePermissionOptions} from './../../../core/model/role';
import {MobileService} from 'src/app/core/page/mobile.service';

@Component({
  selector: 'project-selector-dialog',
  templateUrl: './project-selector-dialog.component.html',
  styleUrls: ['./project-selector-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectSelectorDialogComponent {
  private readonly mobileService = inject(MobileService);
  private SELECTED_PROJECT_ID: string | null = null;
  rolePermissionOptions = RolePermissionOptions;

  get selectedProjectId(): string | null {
    return this.SELECTED_PROJECT_ID;
  }

  set selectedProjectId(value: string | null) {
    if (this.SELECTED_PROJECT_ID !== value) {
      this.SELECTED_PROJECT_ID = value;
    }
  }

  constructor(
    private dialog: MatDialog,
    private dialogRefProjectSelector: MatDialogRef<ProjectSelectorDialogComponent>,
    private dialogRefCreateProject: MatDialogRef<CreateProjectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {projects: Project[]; onFinishedNewTask: () => void; coinTypes: RewardCoin[]}
  ) {}

  onSelectProject(project: Project): void {
    this.dialogRefProjectSelector.close(project);
  }

  openCreateProjectDialog(): void {
    this.dialogRefCreateProject.close();
    this.dialog.open(CreateProjectDialogComponent, {
      autoFocus: this.mobileService.isMobilePlatform() ? false : undefined,
      panelClass: 'create-project-dialog',
      data: {onFinishedNewTask: this.data.onFinishedNewTask, coinTypes: this.data.coinTypes},
    });
  }
}
